var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "myAssistant" },
    [
      _c("div", { staticClass: "myAssistant-content" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "infinite-scroll",
                rawName: "v-infinite-scroll",
                value: _vm.load,
                expression: "load",
              },
            ],
            staticClass: "myAssistant-list",
            attrs: {
              "infinite-scroll-disabled": "disabled",
              "infinite-scroll-distance": 50,
            },
          },
          [
            _vm._l(_vm.aiList, function (item, index) {
              return _c(
                "div",
                {
                  key: item.id,
                  staticClass: "ailist_view",
                  on: {
                    mouseover: function ($event) {
                      item.showBtnUser = true
                    },
                    mouseleave: function ($event) {
                      item.showBtnUser = false
                    },
                    click: function ($event) {
                      return _vm.onhandleUse(item)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "ailist_view_img" },
                    [
                      item.type === 1
                        ? _c("img", {
                            attrs: {
                              src: require("@/assets/image/aigc/my_icon.png"),
                              alt: "",
                            },
                          })
                        : [
                            !!item.icon
                              ? _c("img", {
                                  attrs: { src: item.icon, alt: "" },
                                })
                              : _c(
                                  "div",
                                  {
                                    staticClass: "title-span",
                                    style: { background: item.backgroundColor },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { style: { color: item.textColor } },
                                      [_vm._v(_vm._s(item.title.split("")[0]))]
                                    ),
                                  ]
                                ),
                          ],
                      _c(
                        "div",
                        { class: item.isPrivate ? "private" : "publice" },
                        [
                          _vm._v(
                            " " + _vm._s(item.isPrivate ? "私密" : "公开") + " "
                          ),
                        ]
                      ),
                    ],
                    2
                  ),
                  _c("div", { staticClass: "ailist_detail" }, [
                    _c("div", { staticClass: "ailist_detail_title" }, [
                      _c(
                        "div",
                        { staticClass: "ailist_detail_title_value" },
                        [
                          _c("textShowMore", {
                            attrs: { "line-clamp": 1, text: item.title },
                          }),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "aiHot" }, [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/image/aigc/aiHot.png"),
                          },
                        }),
                        _c("span", [_vm._v(_vm._s(item.useCount))]),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "ailist_detail_describe" },
                      [
                        _c("textShowMore", {
                          attrs: { "line-clamp": 2, text: item.describe },
                        }),
                      ],
                      1
                    ),
                    item.hasUsed
                      ? _c("div", { staticClass: "aiUseingTips" }, [
                          _vm._v("使用中"),
                        ])
                      : _vm._e(),
                    item.status === "INIT"
                      ? _c(
                          "div",
                          { staticClass: "aiInit" },
                          [_vm._v(" 助手初始化中"), _c("loadingView")],
                          1
                        )
                      : _vm._e(),
                  ]),
                  _c("div", { staticClass: "ailist_btn" }, [
                    _c(
                      "div",
                      {
                        staticClass: "ai_btn",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.onhandleRights(item)
                          },
                        },
                      },
                      [_vm._v(" 权限管理 ")]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "ai_btn",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.$emit("editAi", item)
                          },
                        },
                      },
                      [_vm._v("编辑")]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "ai_btn ai_btn_del",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.onhandleDel(item, index)
                          },
                        },
                      },
                      [_vm._v(" 删除 ")]
                    ),
                  ]),
                ]
              )
            }),
            _vm.aiList.length === 0 && _vm.noMore && !_vm.loading
              ? _c("div", { staticClass: "noData" }, [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/image/aiIcon.gif"),
                      alt: "",
                    },
                  }),
                  _c("div", { staticClass: "noDataText" }, [
                    _vm._v("暂无我的助手"),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "add_btn",
                      on: {
                        click: function ($event) {
                          return _vm.$emit("onAdd")
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-plus" }),
                      _c("span", { staticStyle: { "margin-left": "8px" } }, [
                        _vm._v(" 创建AI助手 "),
                      ]),
                    ]
                  ),
                ])
              : _vm._e(),
          ],
          2
        ),
        _vm.loading
          ? _c("div", { staticClass: "myAssistant-loading" }, [
              _c("img", {
                attrs: { src: require("@/assets/image/aigc/loading.gif") },
              }),
            ])
          : _vm._e(),
      ]),
      _c("rightsDialog", { attrs: { config: _vm.rightsDialog } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }